export const Step = ({ stepNumber, translationKey }) => (
    <div className={'p-4 bg-white rounded-3xl text-center border-2'} style={{ borderColor: '#5257E1' }}>
      {stepNumber}. {translationKey}
    </div>
  );

  export const Divider = () => (
    <div className={'h-10 mx-auto lg:block w-[2px] lg:h-[2px] lg:w-full bg-white'} style={{ backgroundColor: '#D9D9D9' }}></div>
  );